import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=f4cf6952&scoped=true"
import script from "./icon-button.vue?vue&type=script&lang=ts"
export * from "./icon-button.vue?vue&type=script&lang=ts"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=f4cf6952&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf6952",
  null
  
)

export default component.exports